import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import {
  randomNumber,
  clearError,
  reduxDefaultStatusControl,
} from 'src/tools/helper';
import { EnumProductType } from 'src/types/common/product';
// import { getProduct } from '@/src/request/product/product';
import {
  validate as _validate,
  settleData,
  convertDatafromServer,
  defaultData,
} from '../tools';
import { isSameType } from '../../tools/commonDataCheck';
import { ProductItem } from 'src/types/common/product';
import { msg } from 'src/tools/message';
import {
  submitProductThunk,
  activateProductThunk,
  draftProductThunk,
  archiveProductThunk,
  duplicateProduct,
} from '../../tools/commonRequests';
import { getLinkedSalesChannels as _getLinkedSalesChannels } from 'src/pages/ProductEditor/tools/selectors';
import { EnumReducers } from 'src/store/constants';
//import { onLinkedSalesChannelsProductsChange as _onLinkedSalesChannelsProductsChange } from 'src/pages/ProductEditor/slice/common';
import { remove } from 'lodash';

const defaultState = {
  ...reduxDefaultStatusControl,
  ...defaultData,
};

export const fetchProduct = createAsyncThunk(
  'fetchSimpleProduct',
  async (a: any) => {
    if (a) {
      const response = await Promise.resolve(a);

      return response;
    } else {
      const response = await Promise.reject();

      return response;
    }
  },
);

function isCurrentType(pro) {
  const { productType } = pro || {};
  return productType === EnumProductType.Simple;
}

function showSavedMsg() {
  msg.success('saved successfully!');
}

function convertProduct(state, product, priceTiers) {
  if (isCurrentType(product)) {
    const updatedProduct = updateState(
      convertDatafromServer(product, priceTiers),
    );
    Object.keys(updatedProduct || {}).forEach((i) => {
      state[i] = updatedProduct[i];
    });
  }
}

const convertStatus = (state, product, priceTiers) => {
  const _p = product;
  convertProduct(state, _p, priceTiers);
  showSavedMsg();
};

const simpleProductSlice = createSlice({
  name: 'simpleProductEditor',
  initialState: defaultState,
  reducers: {
    addMeasurementUnit(state, action) {
      state.measurementUnits = [...state.measurementUnits, action.payload];
    },
    addBrands(state, action) {
      state.brands = [...state.brands, action.payload];
    },
    setProductInfoData(state, action) {
      state.productInfo = {
        ...state.productInfo,
        ...clearError(action.payload),
      };
      state.hasModified = true;
    },
    setTags(state, action) {
      state.tags = { ...state.tags, ...clearError(action.payload) };
      state.hasModified = true;
    },
    setThumbnailImage(state, action) {
      state.thumbnailImage = action.payload;
      state.fileList = [];
      state.hasModified = true;
    },
    setCodes(state, action) {
      const codesCopy = state.productInfo.codes;
      codesCopy.push(action.payload);
      state.productInfo.codes = codesCopy;
      state.hasModified = true;
    },

    setPrice(state, action) {
      state.priceSettings = {
        ...state.priceSettings,
        ...clearError(action.payload),
      };
      state.hasModified = true;
    },
    setAdvancedPrice(state, action) {
      // state.priceSettings = { ...state.priceSettings, ...action.payload };
      const { isDelete, index, settings = {} } = action.payload;
      if (isDelete) {
        state.advancedPriceSettings.splice(index, 1);
      } else {
        state.advancedPriceSettings[index] = {
          ...(state.advancedPriceSettings[index] || {}),
          ...clearError(settings),
        };
      }
      state.hasModified = true;
    },
    // setAdvancedPriceOnBlur(state) {
    //   // state.priceSettings = { ...state.priceSettings, ...action.payload };
    // },
    setAdvancedPriceAddNew(state) {
      state.hasModified = true;
      state.advancedPriceSettings = [
        ...state.advancedPriceSettings,
        {
          key: randomNumber(),
          title: null,
          price: null,
          notes: null,
          currency: null,
        },
      ];
    },
    setAdvancedPriceSettingsOpen(state) {
      state.advancedPriceSettingsOpen = !state.advancedPriceSettingsOpen;
    },
    setDimensions(state, action) {
      state.hasModified = true;
      state.dimensions = { ...state.dimensions, ...clearError(action.payload) };
    },
    deleteCodes(state, action) {
      state.hasModified = true;
      (state.productInfo.codes || []).splice(action.payload.index, 1);
    },
    setCustomInfomationItems(state, action) {
      state.hasModified = true;
      // state.priceSettings = { ...state.priceSettings, ...action.payload };
      const { isDelete, index, settings = {} } = action.payload;

      if (isDelete) {
        state.customsInformationItems.splice(index, 1);
      } else {
        state.customsInformationItems[index] = {
          ...(state.customsInformationItems[index] || {}),
          ...clearError(settings),
        };
      }
    },
    setCustomInfomationItemsAddNew(state) {
      state.hasModified = true;
      state.customsInformationItems = [
        ...(state.customsInformationItems || []),
        {
          key: randomNumber(),
          title: null,
          quantity: null,
          unitPrice: null,
          regionOfOrigin: null,
          hsCode: null,
        },
      ];
    },
    emptyData(state) {
      state.hasModified = false;
      Object.keys(defaultState || {}).forEach((i) => {
        state[i] = defaultState[i];
      });
    },
    setCodesTitle(state, action) {
      const { code, index } = action.payload;
      state.productInfo.codes[index].code = code;
      state.productInfo.codes[index].codeError = false;
      state.hasModified = true;
    },

    validate(state, action) {
      _validate(state, action);
    },

    onHasModifiedChange(state) {
      state.hasModified = true;
    },

    onLinkedSalesChannelsProductsChange(state, action) {
      const { uuid, products } = action.payload;
      state.linkedSalesChannels.forEach((i) => {
        if (i.uuid === uuid) {
          i.products = products || [];
        }
      });
    },
    onLinkedSalesChannelsProductsDelete(state, action) {
      const { salesChannelUuid, productUuid } = action.payload;

      state.linkedSalesChannels.forEach((i) => {
        if (i.uuid === salesChannelUuid) {
          remove(i.products, (x: any) => {
            return x.uuid === productUuid;
          });
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProduct.fulfilled, (state, action: any) => {
      const {
        brands,
        measurementUnits,
        countries,
        currencies,
        inventoryUuid,
        dimensionUnits,
        wightUnits,
        priceTiers,
      } = action.payload;

      const product: ProductItem = action.payload.product || {};
      const linkedSalesChannels = action.payload.linkedSalesChannels || [];
      if (product.uuid) {
        convertProduct(state, product, priceTiers);
      } else {
        state.loaded = true;
        state.advancedPriceSettings = priceTiers.map((i) => {
          //初始化price tier
          const { uuid, title, ...rest } = i;
          return {
            ...rest,
            priceTierUuid: uuid,
            title: title,
            key: randomNumber(),
          };
        });
      }

      state.measurementUnits = measurementUnits;
      state.brands = brands;
      state.countries = countries;
      state.currencies = currencies;
      state.dimensionUnits = dimensionUnits;
      state.wightUnits = wightUnits;
      state.inventoryUuid = inventoryUuid;
      state.linkedSalesChannels = linkedSalesChannels;
      state.priceTiers = priceTiers;
    });
    builder.addCase(fetchProduct.rejected, (state, action) => {
      //state.status = EnumLoadingStatus.FAILED;
    });
    builder.addCase(submitProductThunk.fulfilled, (state, action) => {
      const { response: product, hideMsg } = action.payload;
      const _isCurrentType = isCurrentType(product);
      if (!hideMsg && _isCurrentType) {
        showSavedMsg();
      }
      convertProduct(state, product, state.priceTiers);
    });
    builder.addCase(submitProductThunk.rejected, (state, action) => {
      //state.status = EnumLoadingStatus.FAILED;
    });
    builder.addCase(activateProductThunk.fulfilled, (state, action) => {
      const _p = action.payload;
      convertStatus(state, _p, state.priceTiers);
    });
    builder.addCase(draftProductThunk.fulfilled, (state, action) => {
      const _p = action.payload;
      convertStatus(state, _p, state.priceTiers);
    });
    builder.addCase(archiveProductThunk.fulfilled, (state, action) => {
      const _p = action.payload;
      convertStatus(state, _p, state.priceTiers);
    });
    builder.addCase(duplicateProduct, (state, action) => {
      const { productType, name, status } = action.payload;
      const isSame = isSameType(EnumProductType.Simple, productType);
      if (isSame) {
        state.uuid = null;
        state.productInfo.name = name;
        state.status = status;
        state.productInfo.sku = null;
      }
    });
  },
});
const updateState = (newProduct = {}) => {
  return newProduct;
};
export const getStateSelector = () => {
  return createSelector(
    [(state: any) => state.simpleProduct],
    (simpleProduct) => {
      return settleData(simpleProduct);
    },
  );
};

export const getStatus = () => {
  return createSelector(
    [(state: any) => state.simpleProduct],
    (simpleProduct) => {
      return simpleProduct.status;
    },
  );
};

export const getLinkedSalesChannels = () => {
  return _getLinkedSalesChannels(EnumReducers.simpleProduct);
};

export const {
  setProductInfoData,
  setCodes,
  deleteCodes,
  setCodesTitle,
  setTags,

  setPrice,
  setAdvancedPrice,
  // setAdvancedPriceOnBlur,
  setAdvancedPriceAddNew,
  setAdvancedPriceSettingsOpen,
  setDimensions,
  setCustomInfomationItems,
  setCustomInfomationItemsAddNew,
  emptyData,
  setThumbnailImage,
  validate,
  addMeasurementUnit,
  addBrands,

  onLinkedSalesChannelsProductsChange,
  onLinkedSalesChannelsProductsDelete,
  onHasModifiedChange,
} = simpleProductSlice.actions;

export default simpleProductSlice.reducer;
